;(function() {
  'use strict'

  angular.module('core.filters').filter('timeAgo', timeAgo)

  // --------------------

  function timeAgo() {
    return function(date) {
      var now = moment()
      var then = moment(date)

      // just now (less than 5 mins ago)
      if (now.diff(then, 'minutes') < 5) {
        return 'Just now'
        // today
      } else if (now.isSame(then, 'day')) {
        return then.format('h:mma')
        // yesterday
      } else if (now.subtract(1, 'day').isSame(then, 'day')) {
        return 'Yesterday, ' + then.format('h:mma')
        // date
      } else {
        return then.format('DD MMM, h:mma')
      }
    }
  }
})()
